import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import common from "../assets/languages/common.json";
import translationEN from "../assets/languages/en/login.json";
import translationDE from "../assets/languages/de/login.json";
import translationFR from "../assets/languages/fr/login.json";
import translationIT from "../assets/languages/it/login.json";
import translationES from "../assets/languages/es/login.json";
import { getLocale } from "../utils/getLocale";

const resources = {
  en: {
    translation: Object.assign(translationEN, common),
  },
  de: {
    translation: Object.assign(translationDE, common),
  },
  fr: {
    translation: Object.assign(translationFR, common),
  },
  it: {
    translation: Object.assign(translationIT, common),
  },
  es: {
    translation: Object.assign(translationES, common),
  },
};

export const locales = [
  "en_GB",
  "de_DE",
  "en_AU",
  "en_FI",
  "en_US",
  "en_CA",
  "en_CZ",
  "fr_FR",
  "en_BE",
  "fr_BE",
  "fr_CA",
  "en_DK",
  "es_ES",
  "en_IE",
  "it_IT",
  "en_JP",
  "en_NL",
  "en_NZ",
  "en_NO",
  "en_PL",
  "en_EU",
  "en_WW",
  "en_SE",
  "de_AT",
].sort();

const [language] = getLocale().split("_");

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "en",
    lng: language,
    nsSeparator: ":",
    keySeparator: ".",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: { transKeepBasicHtmlNodesFor: ["br", "strong", "i"] },
  });

export default i18n;
